import { render, staticRenderFns } from "./day-workouts.vue?vue&type=template&id=1994408d"
import script from "./day-workouts.vue?vue&type=script&lang=js"
export * from "./day-workouts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports